import React from 'react'
import { breakpoint, breakpointMax } from '../../__styling'
import {
    StyledPromoBannerWrap,
    StyledTW1000PromoBannerTCs,
    StyledTW1000PromoBannerWrap,
} from './TW1000PromoBanner.styled'

const tw1000PromoBannerDesktop = require('./assets/tw1000PromoBannerDesktop.png')
const tw1000PromoBannerMobile = require('./assets/tw1000PromoBannerMobile.png')

const tw1000TCLinkUrl =
    'https://d2xcq4qphg1ge9.cloudfront.net/assets/511777/3993469/original_FINAL_WAN_20-_20Subscribe_20to_20Win_20Competition.pdf'

const banner190Year = require('./assets/190-year-banner-min.png')
const banner190Yearx2 = require('./assets/190-year-bannerx2-min.png')

export interface bannerProps {
    imageOnly?: boolean
    breachDeal?: string
}

const TW1000PromoBanner = (props: bannerProps) => {
    const imgX1 = banner190Year
    const imgX2 = banner190Yearx2

    return (
        <>
            {props.imageOnly && (
                <StyledPromoBannerWrap>
                    <source srcSet={imgX1} media={breakpoint('xs', false)} />
                    <source srcSet={imgX2} media={breakpointMax('xs', false)} />
                    <img src={imgX1} alt="promotion banner" />
                </StyledPromoBannerWrap>
            )}

            {!props.imageOnly && (
                <StyledTW1000PromoBannerWrap>
                    <source
                        srcSet={tw1000PromoBannerDesktop}
                        media={breakpoint('xs', false)}
                    />
                    <source
                        srcSet={tw1000PromoBannerMobile}
                        media={breakpointMax('xs', false)}
                    />
                    <img
                        src={tw1000PromoBannerDesktop}
                        alt="promotion banner"
                    />
                    <StyledTW1000PromoBannerTCs
                        target="_blank"
                        href={tw1000TCLinkUrl}
                    >
                        Ts and Cs Apply
                    </StyledTW1000PromoBannerTCs>
                </StyledTW1000PromoBannerWrap>
            )}
        </>
    )
}
TW1000PromoBanner.displayName = 'TW1000PromoBanner'

export default TW1000PromoBanner
